import React from 'react';

import { Badge } from '@cowbell/ui';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface OrgCompletionBadgeProps {
  readonly missing: number;
}

/**
 * A panel's completion state, as the design's pill: a green "Complete", or an
 * amber count of the required fields still empty.
 */
export const OrgCompletionBadge = ({ missing }: OrgCompletionBadgeProps) => {
  if (missing === 0) {
    return (
      <Badge
        color="green"
        variant="light"
        radius="xl"
        tt="none"
        leftSection={<CheckCircleOutlineIcon fontSize="inherit" />}
      >
        Complete
      </Badge>
    );
  }

  const noun = missing === 1 ? 'field' : 'fields';

  return (
    <Badge
      color="yellow"
      variant="light"
      radius="xl"
      tt="none"
      leftSection={<ErrorOutlineIcon fontSize="inherit" />}
    >
      {`${missing} required ${noun} left`}
    </Badge>
  );
};

export default OrgCompletionBadge;
